export default __webpack_public_path__ + "static/media/whatever-works.34361b77.gif";